var page = 2;
var loading = false;
var $loadMoreButton = $('.blog--articles .view--more');
 
function loadMoreArticles(e) {
  if(e) e.preventDefault();
  
  if (!loading) {
    loading = true;
    let handle = `${location.href}?view=ajax&page=${page}`;
    
    $.ajax({
      url: handle,
      success: function(data) {           
          $(".blog--articles > .blog--articles--actions").css('display','none');
          $(".all-articles-container").css('display','');        
        if (data.trim()) {
          
          $('#articles-container').append(data);          
          let expectedChilden = (page * 9);
          let actualChildren = $('#articles-container').children().length + $(".blog--articles--container .swiper-wrapper").children().length;
          page++;
          loading = false;
        console.log(expectedChilden);
          console.log(actualChildren);
          
          if(actualChildren < expectedChilden)
            $loadMoreButton.hide(); 
            
        } else {
          $loadMoreButton.hide(); // Hide the button if no more articles/posts are available
        }
      },
      error: function() {
        // Handle error, if any
      }
    });
  }
}

$loadMoreButton.on('click', loadMoreArticles);
